import styled from 'styled-components';

export const ErrorText = styled('div').attrs({ role: 'alert' })`
  color: ${props => props.theme.colors.capsuleRed60};
  font-size: ${props => props.theme.fontSizes.small};
`;
